// extracted by mini-css-extract-plugin
module.exports = {"Details":"Details_Details__1Ipgm","Summary":"Details_Summary__f5rIY","Title":"Details_Title__1YU8a"};